<template>
  <div class="home">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            {{ heading }}
          </h1>
          <div class="is-two-thirds column is-paddingless">

          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="columns pd is-desktop">
          <div class="column is-one-third-desktop">
            <p class="title"><img src="../assets/trinity-stacked.jpg" alt="TCD" /></p>
          </div>
          <div class="column is-half-desktop info">
            <p>
              The <a href="https://www.scss.tcd.ie/disciplines/statistics/" target="_blank">Discipline of Statistics</a> (formerly Department of Statistics) at <a href="www.tcd.ie" target="_blank">Trinity College Dublin</a> is celebrating its 50th year in 2017. This special milestone will be marked by the organisation of an ISA short course and an afternoon of talks, followed by a reception, on Tuesday 14th November.
            </p>
            <p>If you have had a connection to the Department/Discipline in the past as a member of staff, visitor, student or other and would like to receive an RSVP invitation to this event, contact <a href="mailto:wyseja@tcd.ie">wyseja@tcd.ie</a>.</p>
          </div>
        </div>
      </div>

      <div class="columns pd is-multiline is-desktop">
        <div class="column is-one-third-desktop">
          <div class="card">
            <div class="card-content">
              <h2 class="title">Venue of the event</h2>
              <p class="subtitle"><i class="fa fa-map-marker" aria-hidden="true"></i>
                <a href="https://www.google.ie/maps/place/O'Callaghan+Mont+Clare+Hotel/@53.3414972,-6.2530017,17z/data=!3m1!4b1!4m5!3m4!1s0x48670e90db4a8129:0xcf06339f781c38e2!8m2!3d53.341494!4d-6.250813" target="_blank">
                  O'Callaghan Mont Clare Hotel<br />
                  1-4 Merrion Street Lower, Dublin 2
                </a>
              </p>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <h2 class="title">Local organising committee</h2>
              <ul class="subtitle is-vcentered">
                <li><i class="fa fa-user-circle" aria-hidden="true"></i><a href="https://www.scss.tcd.ie/Brett.Houlding/Home.html" target="_blank">Brett Houlding</a></li>
                <li><i class="fa fa-user-circle" aria-hidden="true"></i><a href="http://www.bernardonipoti.com/" target="_blank">Bernardo Nipoti</a></li>
                <li><i class="fa fa-user-circle" aria-hidden="true"></i><a href="http://people.tcd.ie/Profile?Username=moregan" target="_blank">Myra O’Regan</a></li>
                <li><i class="fa fa-user-circle" aria-hidden="true"></i><a href="https://www.scss.tcd.ie/~arwhite/" target="_blank">Arthur White</a></li>
                <li><i class="fa fa-user-circle" aria-hidden="true"></i><a href="https://www.scss.tcd.ie/disciplines/statistics/statica/statica_web/Wilson.html" target="_blank">Simon Wilson</a></li>
                <li><i class="fa fa-user-circle" aria-hidden="true"></i><a href="https://sites.google.com/site/jsnwyse/" target="_blank">Jason Wyse</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="column is-two-thirds-desktop">
          <div class="card schedule">
            <div class="card-content">
              <h2 class="title">Schedule of events</h2>
              <p class="subtitle">Tuesday, 14th of November, 2017</p>
              <ul class="subtitle is-vcentered">
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>9.30 am - 3.30 pm:</span> <router-link to="isa">ISA short course "Imprecise Probability - A Gentle Overview"</router-link> by <a href="http://www.eeecs.qub.ac.uk/~c.decampos/" target="_blank">Cassio P. de Campos</a> (Queen's University Belfast) and <a href="http://people.idsia.ch/~alessandro/" target="_blank">Alessandro Antonucci</a> (Swiss AI Lab IDSIA)</li>
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>4:00 pm:</span> Welcome (Prof. Simon Wilson)</li>
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>4:05 pm:</span> A look at the history of the department (Dr. Michael Stuart)</li>
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>4:20 pm:</span> Discussion and reminisce with former members of the Statistics Department</li>
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>4:50 pm:</span> Panel discussion on the future of and opportunities for statistics at Trinity College, in Ireland and beyond - Panel members: Prof. Adrian Raftery (University of Washington), Dr. Chris Sibley (Central Statistics Office), Mr. Kieran Towey (Accenture Advanced Analytics), Prof. Nial Friel (University College Dublin)</li>
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>5:40 pm:</span> Close and walk over to the <a href="https://www.tcd.ie/Maps/map.php?b=194" target="_blank">O’Reilly Institute</a> foyer for buffet and wine reception</li>
                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>6.00 pm:</span> Reception at the <a href="https://www.tcd.ie/Maps/map.php?b=194" target="_blank">O’Reilly Institute</a> foyer</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
    beforeCreate: function() {
        document.body.className = 'bodyHome';
    },
  data () {
      return{
          heading: '50th Anniversary of the Discipline of Statistics'
      }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../mq"

.hero
  background: url('../assets/front-facade-high.jpg')
  background-size: cover
  min-height: 500px

  .title
    margin-top: 0 !important
    font-size: 3.5rem !important
    +mobile
      font-weight: bold
    +tablet
      font-size: 2.5rem
    +desktop
      font-size: 4rem
      margin-top: 2rem

h2
  margin: 1.5rem 0 2rem 0 !important

.fa-cog
  font-size: 40px

#learn
  +desktop
    margin-bottom: 2rem

.pd
  +tablet
    padding: 2em 0

.column div
  margin-bottom: 15px

.card
  border-radius: 5px
  -moz-border-radius: 5px
  -webkit-border-radius: 5px

  &.schedule
    height: calc(100% - 15px)
    height: -webkit-calc(100% - 15px)
    height:    -moz-calc(100% - 15px)

.card-content
  .subtitle
    margin-top: 10px

ul.subtitle
  padding: 10px 30px

  li
    padding-bottom: 5px

i
  padding: 5px 10px 5px 0
  height: 100%

.info
  padding: 20px

  p
    margin-bottom: 20px

.schedule
  span
    font-style: italic
</style>



// WEBPACK FOOTER //
// src/components/Home.vue?882baf70